import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, inject, LOCALE_ID, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { WorksComponent } from './components/works/works.component';
import { ContactComponent } from './components/contact/contact.component';
import { StarsBackgroundComponent } from './components/stars-background/stars-background.component';
import { BadgesComponent } from './components/badges/badges.component';
import { TermsComponent } from './components/terms/terms.component';
import { PolicyComponent } from './components/policy/policy.component';

export enum Section {
  Home = 'Home',
  About = 'About',
  Works = 'Works',
  Contact = 'Contact',
}

export enum Device {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    HomeComponent,
    AboutComponent,
    WorksComponent,
    BadgesComponent,
    ContactComponent,
    StarsBackgroundComponent,
    TermsComponent,
    PolicyComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less'
})
export class AppComponent implements AfterViewInit {

  @ViewChild('home', { read: ElementRef }) home: ElementRef | undefined;
  @ViewChild('about', { read: ElementRef }) about: ElementRef | undefined;
  @ViewChild('works', { read: ElementRef }) works: ElementRef | undefined;
  @ViewChild('badges', { read: ElementRef }) badges: ElementRef | undefined;
  @ViewChild('contact', { read: ElementRef }) contact: ElementRef | undefined;

  private renderer = inject(Renderer2);
  private route = inject(ActivatedRoute);
  private platformId = inject(PLATFORM_ID);
  locale = inject(LOCALE_ID);
  private cdr = inject(ChangeDetectorRef);

  device: Device = Device.Desktop;

  Device = Device;
  Sections = Section;

  sectionMappings: { [key in Section]?: ElementRef } = {};

  showAbout: boolean = false;
  showWorks: boolean = false;
  showBadges: boolean = false;
  showContact: boolean = false;

  showTerms: boolean = false;
  showPolicy: boolean = false;

  constructor() {
    this.route.fragment.subscribe((fragment: string | null) => {
      if (fragment !== null && fragment === 'policy') {
        this.showPrivacyPolicy();
      } else if (fragment !== null && fragment === 'terms') {
        this.showTermsAndConditions();
      }
    });
  }

  ngAfterViewInit() {

    this.sectionMappings = {
      [Section.Home]: this.home,
      [Section.About]: this.about,
      [Section.Works]: this.works,
      [Section.Contact]: this.contact,
    };

    this.onResize();

    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 50);
    }
  }

  scrollToSection(sectionId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.getElementById(sectionId);
      if (element) {
        // Scroll suave nativo
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  showTermsAndConditions() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showTerms === false) {
        this.showTerms = true;
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 100);
        this.renderer.setStyle(document.body, 'overflow', 'hidden');
      }
    }
  }

  closeTermsAndConditions() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showTerms === true) {
        this.showTerms = false;
        this.renderer.setStyle(document.body, 'overflow', 'auto');
      }
    }
  }

  showPrivacyPolicy() {
    console.log('showPrivacyPolicy');
    if (isPlatformBrowser(this.platformId)) {
      if (this.showPolicy === false) {
        this.showPolicy = true;
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }, 100);
        this.renderer.setStyle(document.body, 'overflow', 'hidden');
      }
    }
  }

  closePrivacyPolicy() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showPolicy === true) {
        this.showPolicy = false;
        this.renderer.setStyle(document.body, 'overflow', 'auto');
      }
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      const screenWidth = window.innerWidth;
      const newDevice = screenWidth > 815 ? Device.Desktop : Device.Mobile;

      if (this.device !== newDevice) {
        this.device = newDevice;
        this.cdr.detectChanges();
      }
    }
  }

  @HostListener("window:scroll")
  checkScroll() {
    const scrollPosition = window.pageYOffset;

    const aboutPosition = this.about?.nativeElement.offsetTop;
    if (scrollPosition >= aboutPosition - 800) {
      this.showAbout = true;
    } else {
      this.showAbout = false;
    }

    const worksPosition = this.works?.nativeElement.offsetTop;
    if (scrollPosition >= worksPosition - 800) {
      this.showWorks = true;
    } else {
      this.showWorks = false;
    }

    const badgesPosition = this.badges?.nativeElement.offsetTop;
    if (scrollPosition >= badgesPosition - 800) {
      this.showBadges = true;
    } else {
      this.showBadges = false;
    }

    const contactPosition = this.contact?.nativeElement.offsetTop;
    if (scrollPosition >= contactPosition - 800) {
      this.showContact = true;
    } else {
      this.showContact = false;
    }
  }

}
